module.exports = __webpack_public_path__ + "fonts/NeutrafaceTextBold.woff2";